import { render, staticRenderFns } from "./ButtonSwitch.vue?vue&type=template&id=f1630eea&scoped=true"
import script from "./ButtonSwitch.vue?vue&type=script&lang=js"
export * from "./ButtonSwitch.vue?vue&type=script&lang=js"
import style0 from "./ButtonSwitch.vue?vue&type=style&index=0&id=f1630eea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1630eea",
  null
  
)

export default component.exports